<script>
export default {
  name: "IndexView",
  data() {
    return {
      memberCount: 0,
      merchantCount: 0,
      orderCount: 0,
      serviceCount: 0,
      productCount: 0
    }
  },
  created() {
    // this.memberTotal();
    // this.merchantTotal();
    // this.orderTotal();
    // this.serviceTotal();
    this.productTotal();
  },
  methods: {
    memberTotal() {
      let _this = this
      this.$axios.post('member/total').then(function (res) {
        console.log(res.data.data)
        _this.memberCount = res.data.data
      }).catch(function (err) {
        console.log(err)
      })
    },
    merchantTotal() {
      let _this = this
      this.$axios.post('merchant/total').then(function (res) {
        console.log(res.data.data)
        _this.merchantCount = res.data.data
      }).catch(function (err) {
        console.log(err)
      })
    },
    orderTotal() {
      this.$axios.post('order/total').then(function (res) {
        console.log(res.data.data)
      }).catch(function (err) {
        console.log(err)
      })
    },
    serviceTotal() {
      this.$axios.post('service/total').then(function (res) {
        console.log(res.data.data)
      }).catch(function (err) {
        console.log(err)
      })
    },
    productTotal() {
      let _this = this
      this.$axios.post('product/total').then(function (res) {
        _this.productCount = res.data.data
      }).catch(function (err) {
        console.log(err)
      })
    }
  }
}
</script>

<template>
  <div class="home" style="height: 100%">
    <div class="module">
      <div class="module-list">
        <!--        <div class="module-item" v-for="item in 4" :key="item">-->
        <!--          <count-to :start-val="startVal" :end-val="endVal" :duration="5000" class="count">20</count-to>-->
        <!--          <div class="count">100</div>-->
        <!--          <div class="name">新增人数</div>-->
        <!--        </div>-->

        <div class="module-item" style="background-color: #7681F8">
<!--          <count-to :start-val="startVal" :end-val="endVal" :duration="5000" class="count">20</count-to>-->
          <div class="count">{{productCount}}</div>
          <div class="name">产品总数</div>
        </div>

<!--        <div class="module-item" style="background-color: #FBB7B7">-->
<!--&lt;!&ndash;          <count-to :start-val="startVal" :end-val="endVal" :duration="5000" class="count">20</count-to>&ndash;&gt;-->
<!--          <div class="count">{{merchantCount}}</div>-->
<!--          <div class="name">商户总数</div>-->
<!--        </div>-->

<!--        <div class="module-item" style="background-color: #9DC8B9">-->
<!--&lt;!&ndash;          <count-to :start-val="startVal" :end-val="endVal" :duration="5000" class="count">20</count-to>&ndash;&gt;-->
<!--          <div class="count">100</div>-->
<!--          <div class="name">订单数量</div>-->
<!--        </div>-->

<!--        <div class="module-item" style="background-color: #F9AF8B">-->
<!--&lt;!&ndash;          <count-to :start-val="startVal" :end-val="endVal" :duration="5000" class="count">20</count-to>&ndash;&gt;-->
<!--          <div class="count">100</div>-->
<!--          <div class="name">服务数量</div>-->
<!--        </div>-->
      </div>
    </div>

    <!--    <div class="container">-->
    <!--      <div class="item">1</div>-->
    <!--      <div class="item">2</div>-->
    <!--      <div class="item">3</div>-->
    <!--      <div class="item">1</div>-->
    <!--      <div class="item">2</div>-->
    <!--      <div class="item">3</div>-->
    <!--    </div>-->
  </div>
</template>

<style>
.module-list {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.module-item {
  width: 23.3%;
  height: 130px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #409EFF;
  border-radius: 5px;
  text-align: center;
  line-height: 50px;
  margin-top: 10px;
}


.module-item:not(:nth-child(4n)) {
  margin-right: 2%;
}

.module-item .count {
  font-size: small;
  color: white;
  font-weight: bold;
  font-size: xx-large;
  margin-top: 15px;
}

.module-item .name {
  font-size: medium;
}


.container {
  display: flex; /* 启用Flex布局 */
  justify-content: space-around; /* 子元素平均分布 */
  border: 1px solid #ccc;
  padding: 10px;
}

.item {
  background: lightblue;
  padding: 20px;
  text-align: center;
  flex: 1; /* 所有子元素等宽 */
  margin: 0 5px; /* 可选间距 */
  border-radius: 5px;
}
</style>
